import { makeSendOtp, makeVerifyOtp, makeLoadOrgStatus } from '@/main/factories/modules/auth'
import { clearTokenOverride, setTokenOverride } from '@/main/factories/http/make-supabase-edge-http-client'
import { SignInPage } from '@/modules/auth/ui'

const sendOtp = makeSendOtp()
const verifyOtp = makeVerifyOtp()
const loadOrgStatus = makeLoadOrgStatus()

export function SignInRoute() {
  return (
    <SignInPage
      onSendOtp={sendOtp}
      onVerifyOtp={verifyOtp}
      onLoadOrgStatus={loadOrgStatus}
      onSetTokenOverride={setTokenOverride}
      onClearTokenOverride={clearTokenOverride}
    />
  )
}
